import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './LoginAlreadyRegister.module.css';

export const LoginAlreadyRegister = ({ onSignInClick = () => { } }) => {
  const { t } = useTranslation('petDemos');

  return (
    <div className={styles.mainContainer}>
      <h1>{t('certificateLinking.alreadyRegistered.title')}</h1>

      <span>{t('certificateLinking.alreadyRegistered.description')}</span>

      <button onClick={onSignInClick} type="button">
        {t('certificateLinking.alreadyRegistered.signIn')}
      </button>
    </div>
  );
};
